import {
  FaExchangeAlt,
  FaBalanceScale,
  FaFileAlt,
} from "@onemind-services-llc/react-icons-ng/fa";
import { MdOutlineSecurity } from "@onemind-services-llc/react-icons-ng/md";
import HeroBg from "public/colocation/hero-section-background.png";

export const NGINX_CONSTANTS = {
  HERO: {
    title: "OneMind Services — NGINX (One-Click Application) ",
    desc: "Deploy NGINX as a high-performance reverse proxy, load balancer, and web server for your applications.",
    button: {
      label: "Try Now",
      link: "contact-us",
    },
    image: HeroBg,
  },
  INTRO: {
    title: "General Information",
    text: "NGINX is a high-performance open-source web server that also functions as a reverse proxy, load balancer, and HTTP cache. It is optimized for serving static content quickly and handling high concurrent connections efficiently, making it ideal for hosting web applications and APIs. ",
  },
  WHY_ONEMIND: {
    title: "Deploy Effortlessly with OneMind Ease ",
    desc: [
      {
        highlight: "One-Click Installation",
        text: " One-Click Installation : Launch a fully configured and secure NGINX instance in minutes—no need to install or manage dependencies. ",
      },
      {
        highlight: "Global Reach",
        text: " Global Reach : Deploy in any of our multiple data-center regions to keep latency low and performance high.  ",
      },
      {
        highlight: "Pre‑Configured Setup",
        text: " Pre‑Configured Setup : Includes NGINX Server, default site directory, and optimized system settings. ",
      },
    ],
    marginTop: 0,
    btnText: "Start Now",
  },
  GET_STARTED: {
    title: "Access & Administration ",
    desc: [
      {
        text: "Once deployed, you’ll receive in your console:",
      },
      {
        text: " Username :",
        highlight: "root",
      },
      {
        text: " Password :",
        highlight: "<generated-password>",
      },
    ],
    connection: {
      text: "Access your default web page at: ",
      command: "http://<YOUR_INSTANCE_IP> ",
    },
    installation: {
      heading: "Installation Location -",
      text: "The configuration file is located in the directory",
      location: " /etc/nginx/nginx.conf ",
    },
    ports: {
      heading: "Ports Used ",
      text: "Application, besides standard Ubuntu Ports (53/22), uses:",
      list: ["80 (HTTP)", "443 (HTTPS)"],
    },
    note: "Note : Find the configuration file at /etc/nginx/nginx.conf for customized tweaks or backup. ",
  },
  FEATURES: {
    items: [
      {
        icon: FaExchangeAlt,
        title: "Reverse Proxy",
        text: "Route and distribute incoming traffic to internal applications or microservices.",
      },
      {
        icon: FaBalanceScale,
        title: "Load Balancing",
        text: "Distribute workloads across multiple servers for better reliability and scalability.",
      },
      {
        icon: MdOutlineSecurity,
        title: "TLS Termination",
        text: "Offload SSL/TLS processing for backend servers while maintaining secure connections.",
      },
      {
        icon: FaFileAlt,
        title: "Static Content Handling",
        text: "Efficiently serves static assets like HTML, CSS, JS, and images.",
      },
    ],
  },
  BENEFITS: {
    title: "Resilience & Scaling ",
    options: [
      {
        label: "Backups & Snapshots",
        text: "Use OneMind’s snapshot feature to back up config and website files. ",
      },
      {
        label: "Security Out of the Box",
        text: "Configured with basic security headers, access restrictions, and TLS support.  ",
      },
      {
        label: "Scalable Architecture",
        text: "Use upstream server pools or containers for horizontal scaling.  ",
      },
    ],
  },
  SUPPORT: {
    docsText: "NGINX Official Docs",
    docsLink: "https://nginx.org/en/docs/",
  },
};
